import React from 'react';

const Profile = () => {
  return (
    <div className="container">
      <div className="card">
        <h1 className="card-title">Profile</h1>
        <p>Profile page - Implementation pending</p>
      </div>
    </div>
  );
};

export default Profile;
